<template>
    <div class="account-setting-wrap">
        <div class="account-setting-container">
            <h2>
                账号设置
            </h2>
            <div class="account-main-container">
                <ul>
                    <li>
                        <div>用户名:</div>
                        <div>{{userNameLogin}}</div>
                    </li>
                    <li>
                        <div>手机:</div>
                        <div>{{userPhone}}</div>
                        <div class="icon-wrap"
                             @click="_clickEdit(1)"><i class="el-icon-edit-outline"></i></div>
                    </li>
                    <li style="position:relative">
                        <div>邮箱:</div>
                        <div class="mail-wrap">
                            <el-input v-model="inputMail"
                                      :style="{'border-color': mailColor}"
                                      class="mail-sty"
                                      @change="valadiateMail"
                                      placeholder="请输入内容"
                                      v-show="!mailVis"></el-input><span v-show="mailVis">{{userMail}}</span>
                        </div>
                        <div class="icon-wrap"><span v-show="!mailVis"
                                  @click="_clickEdit(2)">保存</span><i v-show="mailVis"
                               class="el-icon-edit-outline"
                               @click="()=>{mailVis=!mailVis;inputMail=userMail}"></i></div>
                        <div class="error-text">{{mailText}}</div>
                    </li>
                    <li>
                        <div>密码:</div>
                        <div class="original-input">
                            <!-- <input style="-webkit-appearance: none; -moz-appearance: none; -o-appearance: none; appearance: none;"
                                   type="password"
                                   v-model="inputPwdValue"
                                   disabled> -->
                            已设置
                        </div>
                        <div class="icon-wrap"
                             @click="_clickEdit(3)"><i class="el-icon-edit-outline"></i></div>
                    </li>
                </ul>
            </div>
        </div>
        <el-dialog title="修改密码"
                   :visible.sync="dialogVisible"
                   @close="closeDialogEvents(1)"
                   @open="openDialogEvents(1)"
                   width="600px">
            <div class="dialog-wrap">
                <el-form ref="pwdForm"
                         :model="pwdForm"
                         :rules="pwdRules"
                         :inline="true"
                         :hide-required-asterisk="true"
                         label-width="100px">
                    <el-form-item label="输入原密码:"
                                  prop="oldpaswd">
                        <el-input v-model="pwdForm.oldpaswd"
                                  type="password"
                                  placeholder="请输入原密码"
                                  maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="输入新密码:"
                                  prop="newpaswd">
                        <el-input v-model="pwdForm.newpaswd"
                                  type="password"
                                  placeholder="请输入新密码"
                                  maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="确认新密码:"
                                  prop="paswd"
                                  class="last-form-item">
                        <el-input v-model="pwdForm.paswd"
                                  type="password"
                                  placeholder="请确认新密码"
                                  maxlength="20"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer"
                  class="dialog-footer">
                <a href="javascript:;"
                   @click="_editPwdClick"
                   class="save-button"
                   :disabled="btnReadoOnly">保 存</a>
                <a href="javascript:;"
                   @click="dialogVisible = false"
                   class="cancel-button">取 消</a>
            </span>
        </el-dialog>
        <el-dialog title="修改绑定手机号"
                   @close="closeDialogEvents(2,'phoneForm')"
                   @open="openDialogEvents(2)"
                   :visible.sync="dialogPhoneVisible"
                   width="600px">
            <div class="dialog-phone-wrap">
                <el-form ref="phoneForm"
                         :model="phoneData"
                         :rules="phoneRules"
                         :inline="true"
                         :hide-required-asterisk="true"
                         label-width="100px">
                    <el-form-item label="手机号:"
                                  prop="phoneNumber">
                        <input v-model="phoneData.phoneNumber"
                               :style="{'border-color': activeColor}"
                               class="el-input-sty"
                               placeholder="请输入手机号"
                               maxlength="11"
                               @change="valadiatePhone"
                               @input="phoneData.phoneNumber = phoneData.phoneNumber.replace(/[^\d]/g, '')" />
                    </el-form-item>
                    <!-- <el-form-item label="验证码"
                                  prop="valadateCode"
                                  class="valadate-code-wrap">
                        <el-input v-model="phoneData.valadateCode"
                                  placeholder="请输入验证码"
                                  maxlength="4"></el-input>
                        <div class="img-wrap">
                            <img src=""
                                 alt="">
                        </div>
                    </el-form-item> -->
                    <el-form-item label="短信验证码:"
                                  prop="messageCode"
                                  class="last-form-item message-wrap">
                        <el-input v-model="phoneData.messageCode"
                                  placeholder="请输入短信验证码"></el-input>
                        <div class="button-wrap">
                            <el-button type="warning"
                                       :disabled="codeBtn"
                                       @click="clickGetCode('1')">{{codeBtnText}}</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer"
                  class="dialog-footer">
                <a href="javascript:;"
                   @click="_editPhoneClick(1)"
                   class="save-button">下一步</a>
                <a href="javascript:;"
                   @click="dialogPhoneVisible = false"
                   class="cancel-button">取 消</a>
            </span>
        </el-dialog>
        <el-dialog @close="closeDialogEvents(2,'phoneForm')"
                   @open="openDialogEvents(2,3)"
                   title="绑定新手机号"
                   :visible.sync="dialogPhone2Visible"
                   width="600px">
            <div class="dialog-phone-wrap">
                <el-form ref="phoneForm"
                         :model="phoneData"
                         :rules="phoneRules"
                         :inline="true"
                         :hide-required-asterisk="true"
                         label-width="100px">
                    <el-form-item label="手机号:"
                                  prop="phoneNumber">
                        <input v-model="phoneData.phoneNumber"
                               :style="{'border-color': activeColor}"
                               @change="valadiatePhone"
                               class="el-input-sty"
                               placeholder="请输入手机号"
                               maxlength="11"
                               @input="phoneData.phoneNumber = phoneData.phoneNumber.replace(/[^\d]/g, '')" />
                    </el-form-item>
                    <!-- <el-form-item label="验证码"
                                  prop="valadateCode"
                                  class="valadate-code-wrap">
                        <el-input v-model="phoneData.valadateCode"
                                  placeholder="请输入验证码"
                                  maxlength="4"
                                  @input="_listenCode"></el-input>
                        <div class="img-wrap">
                            <img src=""
                                 alt="">
                        </div>
                    </el-form-item> -->
                    <el-form-item label="短信验证码:"
                                  prop="messageCode"
                                  class="last-form-item message-wrap">
                        <el-input v-model="phoneData.messageCode"
                                  placeholder="请输入短信验证码"></el-input>
                        <div class="button-wrap">
                            <el-button type="warning"
                                       :disabled="codeBtn"
                                       @click="clickGetCode('2')">{{codeBtnText}}</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer"
                  class="dialog-footer">
                <a href="javascript:;"
                   @click="_editPhoneClick(2)"
                   class="save-button">确认</a>
                <a href="javascript:;"
                   @click="dialogPhone2Visible = false"
                   class="cancel-button">取 消</a>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { debuglog } from "util";
import { mapGetters } from "vuex";
import {
    modifyUserPwd,
    loginOut1,
    verificationphone,
    checkSmsCode,
    sendPhoneSmsCode,
    modifyUserPhone,
    getUsers,
    updateEmail
} from "@/api/login";
export default {
    data() {
        return {
            inputMail: "",
            mailText: "",
            inputPwdValue: "46546516",
            mailVis: true,
            codeBtn: false,
            timer: "",
            activeColor: "#c0c4cc",
            mailColor: "",
            phoneNumber: "",
            userName: "",
            customerCode: "",
            userId: "",
            codeBtnText: "获取验证码",
            pwdForm: {
                userId: "",
                oldpaswd: "",
                newpaswd: "",
                paswd: ""
            },
            phoneData: {
                phoneNumber: "",
                valadateCode: "",
                messageCode: ""
            },
            phoneRules: {
                phoneNumber: [
                    {
                        required: true,
                        message: "请输入电话/固话",
                        trigger: "blur"
                    },
                    {
                        pattern: /^1\d{10}$|^0\d{10,11}$/,
                        message: "手机/固话格式有误",
                        trigger: "blur"
                    }
                ],
                // valadateCode: [
                //     {
                //         required: true,
                //         message: "请输入图片验证码",
                //         trigger: "change"
                //     }
                // ],
                messageCode: [
                    {
                        required: true,
                        message: "请输入短信验证码",
                        trigger: "blur"
                    },
                    {
                        pattern: /^\d{6}$/,
                        message: "短信验证码有误",
                        trigger: "blur"
                    }
                ]
            },
            pwdRules: {
                oldpaswd: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "change"
                    },
                    {
                        pattern: /^(?![a-z]+$)(?![A-Z]+$)(?![_!@#$%^&*`~()-+=]+$)(?![0-9]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,20}$/,
                        message:
                            "8-20位的数字/字母/特殊字符组成,至少包含其中两种",
                        trigger: "blur"
                    }
                ],
                newpaswd: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "change"
                    },
                    {
                        pattern: /^(?![a-z]+$)(?![A-Z]+$)(?![_!@#$%^&*`~()-+=]+$)(?![0-9]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,20}$/,
                        message:
                            "8-20位的数字/字母/特殊字符组成,至少包含其中两种",
                        trigger: "blur"
                    }
                ],
                paswd: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "change"
                    },
                    {
                        pattern: /^(?![a-z]+$)(?![A-Z]+$)(?![_!@#$%^&*`~()-+=]+$)(?![0-9]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,20}$/,
                        message:
                            "8-20位的数字/字母/特殊字符组成,至少包含其中两种",
                        trigger: "blur"
                    }
                ]
            },
            dialogVisible: false,
            dialogPhoneVisible: false,
            dialogPhone2Visible: false,
            btnReadoOnly: true
        };
    },
    computed: {
        ...mapGetters(["userNameLogin", "userPhone", "userMail", "userIds"])
    },
    mounted() {
        // this.phoneNumber = userPhone;
        if (sessionStorage.getItem("userInfoView")) {
            let userObject = JSON.parse(sessionStorage.getItem("userInfoView"));
            // this.userName = userObject.userName;
            // this.phoneNumber = userObject.phoneNumber;
            this.userId = userObject.userId;
            this.customerCode = userObject.customerCode;
        }
        debugger;
        //if (this.userId) {
        this.getUserId(this.userId);
        //}
    },

    methods: {
        _clickEdit(val) {
            switch (val) {
                case 1:
                    this.dialogPhoneVisible = true;
                    this.phoneData.phoneNumber = this.userPhone;
                    this.$set(this.phoneData, "phoneNumber", this.userPhone);
                    // this.$refs.phoneForm.resetFields();
                    this.phoneData.valadateCode = "";
                    this.phoneData.messageCode = "";
                    this.codeBtnText = "获取验证码";
                    this.codeBtn = false;
                    break;
                case 2:
                    if (this.valadiateMail()) {
                        this.mailVis = !this.mailVis;
                        this.mailColor = "#c0c4cc";
                        this.editMail();
                    }
                    break;
                case 3:
                    this.dialogVisible = true;
                    // this.$refs.pwdForm.resetFields();
                    break;
                default:
            }
        },

        getUserId(params) {
            // sessionStorage.getItem();
            getUsers().then(res => {
                debugger;
                if (res.indexOf("<!DOCTYPE html>") !== -1) {
                    window.location.href =
                        process.env.VUE_APP_CAS +
                        "?service=" +
                        window.location.href.replace("#", "%23");
                }
            });
        },
        //退出
        loginOut() {
            sessionStorage.clear();
            loginOut1().then(res => {
                if (res) {
                    this.$store.dispatch("changeUserName", "");
                    this.$router.push("/");
                }
            });
        },
        // 修改邮箱
        editMail() {
            if (this.inputMail == this.userMail) {
                //this.open7("邮箱一样");
                return;
            }
            let params = {
                userId: this.userId,
                email: this.inputMail
            };
            updateEmail(params).then(res => {
                if (res) {
                    debugger;
                    this.$message.success("修改邮箱成功");
                    this.$store.dispatch("changeUserMail", this.inputMail);
                }
            });
        },
        //提示信息
        open7(val) {
            this.btnReadoOnly = true;
            this.$message({
                showClose: true,
                message: val,
                type: "warning"
            });
        },
        open6(val) {
            this.btnReadoOnly = true;
            this.$message({
                showClose: true,
                message: val,
                type: "success"
            });
        },
        //修改密码
        _editPwdClick() {
            this.$refs["pwdForm"].validate(valid => {
                if (valid) {
                    //修改密码
                    if (this.btnReadoOnly) {
                        this.btnReadoOnly = false;
                        let oldword = this.pwdForm.oldpaswd;
                        let word = this.pwdForm.paswd;
                        let newpaswd = this.pwdForm.newpaswd;
                        const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,20}$/;
                        if (oldword === word) {
                            this.open7("新密码和当前密码不能一致");
                        } else if (word !== newpaswd) {
                            this.open7("新密码和确认密码不一致");
                        } else {
                            modifyUserPwd({
                                //修改密码
                                oldPassword: oldword,
                                password: word,
                                phoneNumber: this.userPhone,
                                userId: this.userId
                            })
                                .then(result => {
                                    if (
                                        result.status == 2000 &&
                                        result.data.success
                                    ) {
                                        //请求成功关闭弹框
                                        this.btnReadoOnly = true;
                                        this.dialogVisible = false;
                                        this.loginOut();
                                    } else {
                                        this.btnReadoOnly = true;
                                        this.open7(result.data.errorMessages);
                                    }
                                })
                                .catch(data => {
                                    this.open7(data);
                                });
                        }
                    } else {
                        this.open7("禁止重复提交!");
                    }
                }
            });
        },
        //发送验证码
        yanm(phone) {
            this.activeColor = "#67c23a";
            this.codeBtnText = 60;
            this.settime();
            sendPhoneSmsCode({
                phoneNumber: phone,
                smsOperationType: "modPhone" //发送短信的类型
            })
                .then(res => {
                    if (res.status === 2000) {
                        this.open7("已发送");
                    } else {
                        this.open7(res.data);
                    }
                })
                .catch(data => {
                    this.open7(data);
                });
        },
        short() {
            if (this.dialogFormVisible3) {
                verificationphone({
                    phoneNumber: this.phone
                })
                    .then(result => {
                        //新手机号获取验证码
                        if (result.success) {
                            this.open7("该手机号已存在绑定关系");
                        } else {
                            this.yanm();
                        }
                    })
                    .catch(data => {
                        this.open7("修改失败" + data);
                    });
            } else {
                //第一步获取验证码
                if (this.phone !== this.phoneNumber) {
                    this.open7("请输入原手机号码");
                } else {
                    this.yanm();
                }
            }
        },
        //  下一步-------------------------------------------
        _editPhoneClick(val) {
            this.valadiatePhone();
            this.$refs["phoneForm"].validate(valid => {
                if (valid) {
                    //请求成功关闭弹框
                    if (val === 1) {
                        this.settoldphone(
                            this.phoneData.phoneNumber,
                            this.phoneData.messageCode,
                            val
                        );
                    } else if (val === 2) {
                        this.setphone(
                            this.phoneData.phoneNumber,
                            this.phoneData.messageCode
                        );
                    }
                }
            });
        },
        //修改手机号操作
        setphone(phone, messageCode) {
            //修改手机号
            modifyUserPhone({
                smsCode: messageCode,
                phoneNumber: phone,
                userId: this.userId,
                customerCode: this.customerCode,
                smsOperationType: "modPhone" //发送短信的类型
            })
                .then(result => {
                    if (result.data.success) {
                        this.open6("修改成功");
                        this.loginOut();
                    } else {
                        this.open7(result.errorMessages);
                    }
                })
                .catch(data => {
                    this.open7("修改失败" + data);
                });
        },
        //验证信息
        settoldphone(phone, scode, val) {
            checkSmsCode({
                smsCode: scode,
                phoneNumber: phone,
                smsOperationType: "modPhone" //发送短信的类型
            })
                .then(result => {
                    if (result.status == 2000) {
                        if (result.data.success) {
                            // this.open6("校验成功");
                            if (val === 1) {
                                this.phoneData = {
                                    phoneNumber: "",
                                    valadateCode: "",
                                    messageCode: ""
                                };
                                this.codeBtn = false;
                                clearTimeout(this.timer);
                                this.codeBtnText = "获取验证码";
                                this.activeColor = "#c0c4cc";
                                this.dialogPhoneVisible = false;
                                this.dialogPhone2Visible = true;
                            } else {
                                this.dialogPhone2Visible = false;
                            }
                        } else {
                            this.open7(result.data.errorMessages);
                        }
                    }
                })
                .catch(data => {
                    this.open7("修改失败" + data);
                });
        },

        _listenCode() {
            if (
                this.phoneData.valadateCode &&
                this.phoneData.valadateCode.length === 4 &&
                this.codeBtnText == "获取验证码"
            ) {
                this.codeBtn = false;
            } else {
                this.codeBtn = true;
            }
        },
        //获取验证码
        clickGetCode(val) {
            this.$refs.phoneForm.validateField("phoneNumber", phoneError => {
                if (!phoneError) {
                    if (val === "1") {
                        if (this.userPhone !== this.phoneData.phoneNumber) {
                            this.open7("请输入原手机号码");
                        } else {
                            this.yanm(this.phoneData.phoneNumber);
                        }
                    } else if (val === "2") {
                        //新手机号是否有绑定关系
                        verificationphone({
                            phoneNumber: this.phoneData.phoneNumber
                        })
                            .then(result => {
                                //新手机号获取验证码
                                if (result.data.success) {
                                    this.open7("该手机号已存在绑定关系");
                                } else {
                                    this.yanm(this.phoneData.phoneNumber);
                                }
                            })
                            .catch(data => {
                                this.open7("修改失败" + data);
                            });
                    }
                } else {
                    this.activeColor = "#f56c6c";
                }
            });
        },
        valadiatePhone() {
            this.$refs.phoneForm.validateField("phoneNumber", phoneError => {
                if (!phoneError) {
                    this.activeColor = "#67c23a";
                } else {
                    this.activeColor = "#f56c6c";
                }
            });
        },
        // 校验邮箱
        valadiateMail() {
            const reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
            if (!this.inputMail) {
                this.mailColor = "#f56c6c";
                this.mailText = "邮箱不能是空";
            } else if (!reg.test(this.inputMail)) {
                this.mailColor = "#f56c6c";
                this.mailText = "请输入正确的邮箱格式";
            } else {
                this.mailColor = "#67c23a";
                this.mailText = "";
                return true;
            }
        },
        settime() {
            if (this.codeBtnText === 0) {
                this.codeBtnText = "获取验证码";
                this.codeBtn = false;
            } else {
                this.codeBtnText--;
                this.codeBtn = true;
                this.timer = setTimeout(() => {
                    this.settime();
                }, 1000);
            }
        },
        closeDialogEvents(val, formName) {
            this.$refs[formName].resetFields();
            if (val === 2) {
                clearTimeout(this.timer);
                this.activeColor = "#c0c4cc";
            } else {
                // this.$refs.pwdForm.resetFields();
            }
        },
        openDialogEvents(val, newVal) {
            if (val === 2) {
                // this.$refs.phoneForm.resetFields();
                if (newVal == 3) {
                    this.phoneData.phoneNumber = "";
                    this.$set(this.phoneData, "phoneNumber", "");
                    this.$forceUpdate();
                } else {
                    this.phoneData.phoneNumber = this.userPhone;
                    this.$set(this.phoneData, "phoneNumber", this.userPhone);
                    this.$forceUpdate();
                }
            } else {
                // this.$refs.pwdForm.resetFields();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.account-setting-wrap {
    .el-icon-edit-outline {
        color: #fabe00;
    }
    background-color: #f5f6f7;
    .account-setting-container {
        width: 1200px;
        margin: 0 auto;
        background-color: #f5f6f7;
        > h2 {
            color: #000024;
            font-size: 32px;
            font-weight: bold;
            padding: 40px 0;
        }
        .account-main-container {
            padding: 50px 40px;
            min-height: 500px;
            background-color: #fff;
            ul {
                list-style: none;
                margin: 0;
                padding: 0;
                li {
                    font-size: 14px;
                    color: #000000;
                    width: 320px;
                    position: relative;
                    div:first-child {
                        width: 25%;
                        display: inline-block;
                        vertical-align: middle;
                    }
                    div:nth-child(2) {
                        width: 75%;
                        display: inline-block;
                    }
                    .icon-wrap {
                        position: absolute;
                        cursor: pointer;
                        top: 0;
                        right: -30px;
                        font-size: 16px;
                        &:hover {
                            color: #fabe00;
                        }
                        span {
                            display: inline-block;
                            padding-top: 7px;
                        }
                    }
                    .mail-wrap {
                        .mail-sty {
                            border: 1px solid #c0c4cc;
                            border-radius: 5px;
                        }
                        // min-height: 35px;
                        /deep/ .el-input {
                            width: 225px;
                        }
                        /deep/ .el-input__inner {
                            height: 34px;
                            line-height: 34px;
                            border: none;
                        }
                    }
                    .error-text {
                        position: absolute;
                        left: 80px;
                        top: 40px;
                        color: #f56c6c;
                    }
                }
                li + li {
                    margin-top: 60px;
                }
            }
        }
    }
    .save-button {
        display: inline-block;
        background-color: #fabe00;
        color: #fff;
        font-size: 18px;
        width: 120px;
        height: 40pox;
        line-height: 40px;
        border-radius: 2px;
        &:hover {
            background-color: #fabe00;
        }
        &:active {
            background-color: #fabe00;
        }
    }
    .cancel-button {
        margin-left: 20px;
        display: inline-block;
        border-radius: 2px;
        font-size: 18px;
        width: 120px;
        height: 40pox;
        line-height: 40px;
        color: #000000;
        border: 1px solid #dddddd;
    }
    .original-input {
        input {
            -webkit-appearance: none;
            -moz-appearance: none;
            -o-appearance: none;
            appearance: none;
        }
        input {
            background: none;
            outline: none;
            border: none;
        }
    }
    .dialog-wrap {
        text-align: center;
        /deep/ .el-form-item__label {
            text-align: left;
        }
        /deep/ .el-input__inner {
            height: 34px;
            line-height: 34px;
        }
        /deep/ .el-input {
            width: 300px;
        }
        /deep/ .el-form-item__error {
            left: 0;
        }
    }
    .dialog-phone-wrap {
        input::-webkit-input-placeholder {
            color: #c0c4cc;
        }
        input::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #c0c4cc;
        }
        input:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: #c0c4cc;
        }
        input:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: #c0c4cc;
        }
        .el-input-sty {
            width: 280px;
            height: 34px;
            box-sizing: border-box;
            margin-left: 20px;
            line-height: 34px;
            -webkit-appearance: none;
            -moz-appearance: none;
            -o-appearance: none;
            appearance: none;
            background: none;
            outline: none;
            border: 1px solid #c0c4cc;
            padding: 0 20px;
            border-radius: 5px;
            &:focus {
                // border-color: #fabe00;
            }
        }
        text-align: center;
        /deep/ .el-form-item__label {
            text-align: right;
        }
        /deep/ .el-input__inner {
            height: 34px;
            line-height: 34px;
        }
        /deep/ .el-input {
            width: 280px;
            margin-left: 20px;
        }
        .valadate-code-wrap {
            /deep/ .el-input {
                width: 160px;
            }
            .img-wrap {
                float: right;
                display: inline-block;
                width: 97px;
                height: 34px;
                margin-left: 23px;
                padding-top: 3px;
                img {
                    height: 100%;
                    width: 100%;
                    overflow: hidden;
                }
            }
        }
        .message-wrap {
            /deep/ .el-input {
                width: 160px;
            }
            .button-wrap {
                float: right;
                display: inline-block;
                width: 97px;
                height: 34px;
                margin-left: 23px;
                /deep/ .el-button {
                    padding: 9px 12px;
                }
                .el-button--warning.is-disabled {
                    background-color: #d9d9d9;
                    // border-color: #d9d9d9;
                    &:hover {
                        background-color: #d9d9d9;
                        border-color: #d9d9d9;
                    }
                    &:active {
                        background-color: #d9d9d9;
                        // border-color: #d9d9d9;
                    }
                }
                .el-button--warning {
                    width: 97px;
                    background-color: #fabe00;
                    // border-color: #fabe00;
                    &:hover {
                        background-color: #fabe00;
                        // border-color: #fabe00;
                    }
                    &:active {
                        background-color: #fabe00;
                        // border-color: #fabe00;
                    }
                }
            }
        }
    }
    /deep/ .el-dialog__header {
        border-bottom: 1px solid #e8e8e8;
    }
    /deep/ .el-dialog__footer {
        text-align: center;
        padding-bottom: 30px;
    }
    /deep/ .last-form-item {
        margin-bottom: 0 !important;
    }
    /deep/ .el-form-item__error {
        left: 20px;
    }
}
</style>